import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { Grid } from '@mui/material';
// components
import { RHFTextField, RHFNumericField } from '../../../../../components/hook-form';
import CardSection from '../../../../../components/card-section';

//-------------------------------------------------------------------------------------------------

const ClassCodeFields = ({ onRemove, isRemoveDisabled, index, setAnnualPayrollInState, initialAnnualPayroll }) => {
  // state
  const [annualPayroll, setAnnualPayroll] = useState(initialAnnualPayroll);

  const handleAnnualPayrollChange = (event) => {
    setAnnualPayrollInState(event.target.value, index);
    setAnnualPayroll(event.target.value);
  };

  return (<CardSection title={`Class code #${index + 1}`} onRemove={() => onRemove(index)} isRemoveDisabled={isRemoveDisabled}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={2}>
        <RHFTextField name={`coverageAndClasses.classCodes[${index}].code`} label={'Code'} />
      </Grid>
      <Grid item xs={12} sm={2}>
        <RHFTextField name={`coverageAndClasses.classCodes[${index}].description`} label={'Description'} />
      </Grid>
      <Grid item xs={12} sm={2}>
        <RHFTextField name={`coverageAndClasses.classCodes[${index}].fullTime`} label={'Full time'} />
      </Grid>
      <Grid item xs={12} sm={2}>
        <RHFTextField name={`coverageAndClasses.classCodes[${index}].partTime`} label={'Part time'} />
      </Grid>
      <Grid item xs={12} sm={2}>
        <RHFNumericField name={`coverageAndClasses.classCodes[${index}].annualPayroll`} value={annualPayroll} label={'Annual Payroll'} onChange={handleAnnualPayrollChange}/>
      </Grid>
      <Grid item xs={12} sm={2}>
        <RHFTextField name={`coverageAndClasses.classCodes[${index}].locNumber`} label={'Loc #'} />
      </Grid>
    </Grid>
  </CardSection>);
};

ClassCodeFields.propTypes = {
  onRemove: PropTypes.func,
  isRemoveDisabled: PropTypes.bool,
  index: PropTypes.number,
  setAnnualPayrollInState: PropTypes.func,
  initialAnnualPayroll: PropTypes.string,
};

export default ClassCodeFields;
